// import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { offersAction } from 'store';
import { ROUTES } from 'utils/routeNames';
import { RequestsPageLayout } from 'Layout/RequestsPageLayout';
// import { Images } from 'assets/images';
import {
  AboutOfferDescription,
  DescriptionContainer,
  DescriptionMainBlock,
  ImageContainer,
  InfoWrapper,
  OfferImage,
  OffersSectionWrapper,
  OfferStyledWrapper,
  OfferTitle,
  ParagraphInfo,
  SeeMoreButton,
  SeeMoreButtonContainer,
  TitleParagraph,
  UserOfferCards,
} from 'containers/Requests/fragments/Offers/styled';

export const OfferItem = () => {
  //const [heart, setHeart] = useState(false);
  const { offer } = useSelector((state) => state.offersReducer);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(offersAction.getOffer(id));
  }, []);

  return (
    <RequestsPageLayout>
      <UserOfferCards areOffers>
        <OfferStyledWrapper>
          <OffersSectionWrapper>
            {offer?.package?.map((item) => (
              <AboutOfferDescription key={uuid()}>
                <ImageContainer>
                  {/* <LikeIcon onClick={() => setHeart(!heart)} aria-label="add to favorites">
              <LikeImg src={heart ? Images.fillHeart : Images.heart} alt="heart" />
            </LikeIcon> */}

                  <OfferImage backgroundImage={item?.main_image} areOffers />
                </ImageContainer>

                <DescriptionContainer areOffers>
                  <DescriptionMainBlock>
                    <OfferTitle>{item?.title}</OfferTitle>

                    <InfoWrapper>
                      <TitleParagraph>Price:</TitleParagraph>
                      <ParagraphInfo>{item?.price} for 1 person</ParagraphInfo>
                    </InfoWrapper>

                    <InfoWrapper>
                      <TitleParagraph>Population:</TitleParagraph>
                      <ParagraphInfo>{item?.population}</ParagraphInfo>
                    </InfoWrapper>

                    <InfoWrapper>
                      <TitleParagraph>Language: </TitleParagraph>
                      <ParagraphInfo>{item?.language}</ParagraphInfo>
                    </InfoWrapper>
                  </DescriptionMainBlock>

                  <SeeMoreButtonContainer>
                    <SeeMoreButton
                      onClick={() => navigate(`${ROUTES.OFFER}/${item.id}`)}
                      type="button"
                    >
                      See More
                    </SeeMoreButton>
                  </SeeMoreButtonContainer>
                </DescriptionContainer>
              </AboutOfferDescription>
            ))}
          </OffersSectionWrapper>
        </OfferStyledWrapper>
      </UserOfferCards>
    </RequestsPageLayout>
  );
};
